<template>
  <div class="main-sidebar">
    <aside id="sidebar-wrapper">
      <div class="sidebar-brand">
        <a href="/">
          <img
            src="./../../assets/img/icon-jembrana-20.png"
            alt="logo"
            width="30"
            class="mr-2"
          >
          SiPeDuLi Jembrana
        </a>
      </div>
      <div class="sidebar-brand sidebar-brand-sm">
        <a href="/">
          <img
            src="./../../assets/img/icon-jembrana-20.png"
            alt="logo"
            width="30"
          >
        </a>
      </div>

      <!-- sidebar penduduk -->
      <SidebarPenduduk />

      <!-- sidebar kepala dusuun -->
      <SidebarKepalaDusun />

      <!-- sidebar operator desa -->
      <SidebarOperatorDesa />

      <!-- sidebar kepala desa -->
      <SidebarKepalaDesa />

      <!-- sidebar kecamatan -->
      <SidebarOperatorKecamatan />

      <!-- sidebar operator dukcapil -->
      <SidebarOperatorDukcapil />

      <!-- sidebar admin -->
      <SidebarAdmin />

      <!-- sidebar umkm -->
      <SidebarUmkm />

      <!-- sidebar jasa antar -->
      <SidebarJasaAntar />

      <!-- sidebar rumah sakit -->
      <SidebarRumahSakit />

      <div class="mt-4 mb-4 p-3 hide-sidebar-mini">
        <router-link
          to="/panduan"
          class="btn btn-primary btn-lg btn-block btn-icon-split"
        >
          <i class="far fa-list-alt" /> Petunjuk Aplikasi
        </router-link>
      </div>
    </aside>
  </div>
</template>

<script>
import SidebarPenduduk from './sidebar/SidebarPenduduk.vue'
import SidebarKepalaDusun from './sidebar/SidebarKepalaDusun.vue'
import SidebarOperatorDesa from './sidebar/SidebarOperatorDesa.vue'
import SidebarKepalaDesa from './sidebar/SidebarKepalaDesa.vue'
import SidebarOperatorKecamatan from './sidebar/SidebarOperatorKecamatan.vue'
import SidebarOperatorDukcapil from './sidebar/SidebarOperatorDukcapil.vue'
import SidebarAdmin from './sidebar/SidebarAdmin.vue'
import SidebarUmkm from './sidebar/SidebarUmkm.vue'
import SidebarJasaAntar from './sidebar/SidebarJasaAntar.vue'
import SidebarRumahSakit from './sidebar/SidebarRumahSakit.vue'

export default {
	data() {
		return {
      // TODO: menu nya diginiin aja
      menu: [
        {route: '/penduduk', title: 'Home', role: ['Penduduk']},
        {route: '/permohonan/buat-permohonan', title: 'Buat Permohonan', role: ['Penduduk', 'Operator Desa']},
        {route: '/permohonan/data-permohonan', title: 'Data Permohonan', role: ['Penduduk', 'Operator Desa', 'Operator Kecamatan', 'Operator Dukcapil Kecamatan', 'Operator Dukcapil', 'Admin Laksita', 'Admin Jembrana']},
        {route: '/info-layanan', title: 'Layanan', role: ['Penduduk', 'Operator Desa', 'Operator Kecamatan', 'Operator Dukcapil Kecamatan', 'Operator Dukcapil', 'Admin Laksita', 'Admin Jembrana']}
      ]
		}
	},
  components: {
    SidebarPenduduk, SidebarKepalaDusun, SidebarOperatorDesa,
    SidebarKepalaDesa, SidebarOperatorKecamatan, SidebarOperatorDukcapil,
    SidebarOperatorDukcapil, SidebarAdmin, SidebarUmkm, SidebarJasaAntar,
    SidebarRumahSakit
  },
	computed: {
		authService(){
			return this.$store.getters.getAuthService
		}
	},
	created(){

	}
}
</script>